import {
    ContactNote,
    CreateContactNoteRequest,
    UpdateContactNoteRequest,
} from '../../types/ContactNote';
import { libApiInstance } from '../axios';

//Get All Notes
export async function requestContactNotes(
    contactId: number,
    signal?: AbortSignal,
): Promise<ContactNote[]> {
    const result = await libApiInstance.get(`/contacts/${contactId}/notes`, {
        signal,
    });

    return result.data;
}

export async function requestDeleteContactNote(
    contactId: number,
    noteId: number,
    signal?: AbortSignal,
) {
    return libApiInstance.delete(`/contacts/notes/${noteId}`, { signal });
}

export async function requestCreateContactNote(data: CreateContactNoteRequest) {
    return libApiInstance.post('/contacts/notes', data);
}

export async function requestEditContactNote(data: UpdateContactNoteRequest) {
    return libApiInstance.put(`/contacts/notes/${data.noteId}`, data);
}
